
    import {defineComponent, reactive} from 'vue'
    import {useRoute,useRouter} from "vue-router";
    import utils from '@/util/index';

    interface State {
        isPc: number;
    }

    export default defineComponent({
        setup() {
            let state: State = reactive({
                isPc: 0
            });
            const {query} = useRoute()
            const router = useRouter()
            // 判断当前机型 移动端的话带着所有参数跳转/h5 pc端的话带着所有参数跳转/pc
            state.isPc = utils.getUserBrowser()
            if(state.isPc === 0){
                router.push({
                    path: '/h5',
                    query
                })
            }else if(state.isPc === 1){
                router.push({
                    path: '/pc',
                    query
                })
            }
            return{
                state
            }
        }
    })
